/* ============================================================
   STEIN & VOSS — Produktgalerie-Steuerung (Bose-Stil)
   1) Pfeile auf dem Hauptbild (Desktop): wechselt Medium +
      synchronisiert die Thumbnail-Markierung.
   2) Lightbox: Klick aufs Hauptbild öffnet eine Vollbild-
      Ansicht (ein Bild, Pfeile, Thumbnails, X zum Schließen).
   Mobile: Dawn-Slider-Verhalten bleibt unverändert.
   ============================================================ */
(function () {
  'use strict';

  var desktop = window.matchMedia('(min-width: 750px)');

  /* ---------- Gemeinsame Helfer ---------- */

  function getMediaList() {
    // Sichtbare Thumbnails = verbindliche Reihenfolge (respektiert Varianten-Filter)
    var thumbs = Array.prototype.filter.call(
      document.querySelectorAll('.thumbnail-list [data-target]'),
      function (li) {
        return li.offsetParent !== null && li.querySelector('.thumbnail');
      }
    );

    var media = [];
    thumbs.forEach(function (li) {
      var id = li.getAttribute('data-target');
      var item = document.querySelector('.product__media-item[data-media-id="' + id + '"]');
      if (!item || !item.querySelector('.media-type-image')) return;
      var img = item.querySelector('img');
      if (!img) return;
      var base = (img.getAttribute('src') || img.currentSrc || '').split('?')[0];
      media.push({
        id: id,
        full: base + '?width=1600',
        thumb: base + '?width=112',
        alt: img.alt || ''
      });
    });
    return media;
  }

  var imageRequest = 0;
  function preloadNeighbors(mediaId) {
    var images = Array.from(document.querySelectorAll('.product__media-item .product__modal-opener--image img'));
    var index = images.findIndex(img => img.closest('[data-media-id]').dataset.mediaId === mediaId);
    [images[index - 1], images[index + 1]].filter(Boolean).forEach(img => { img.loading = 'eager'; img.decode().catch(() => {}); });
  }
  async function setActiveMedia(mediaId) {
    var request = ++imageRequest;
    var target = document.querySelector('.product__media-item[data-media-id="' + mediaId + '"]');
    var image = target?.querySelector('img');
    if (image) {
      image.loading = 'eager';
      try { await image.decode(); } catch { if (!image.naturalWidth) return; }
      if (request !== imageRequest) return;
    }
    var list = document.querySelector('.product__media-list');
    if (list) {
      Array.prototype.forEach.call(list.querySelectorAll('.product__media-item'), function (item) {
        if (item.getAttribute('data-media-id') === mediaId) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });
    }
    Array.prototype.forEach.call(document.querySelectorAll('.thumbnail-list [data-target]'), function (li) {
      var btn = li.querySelector('.thumbnail');
      if (!btn) return;
      if (li.getAttribute('data-target') === mediaId) {
        btn.setAttribute('aria-current', 'true');
      } else {
        btn.removeAttribute('aria-current');
      }
    });
  }

  var firstMedia = document.querySelector('.product__media-item.is-active');
  if (firstMedia) setTimeout(() => preloadNeighbors(firstMedia.dataset.mediaId), 1200);
  document.addEventListener('click', event => {
    var target = event.target.closest('.thumbnail-list [data-target]');
    if (target) preloadNeighbors(target.dataset.target);
  });

  /* ---------- Pfeile auf dem Hauptbild (nur Desktop) ---------- */

  document.addEventListener(
    'click',
    function (event) {
      if (!desktop.matches) return;

      var button = event.target.closest('.slider-button');
      if (!button) return;

      var viewer = button.closest('slider-component.slider-mobile-gutter');
      if (!viewer || viewer.classList.contains('thumbnail-slider')) return;
      if (viewer.id.indexOf('GalleryViewer-') !== 0) return;
      if (!viewer.querySelector('.slider-buttons.sv-has-multi')) return;

      var media = getMediaList();
      if (media.length < 2) return;

      var activeItem = document.querySelector('.product__media-item.is-active');
      var activeId = activeItem ? activeItem.getAttribute('data-media-id') : null;
      var current = media.findIndex(function (m) { return m.id === activeId; });
      if (current === -1) current = 0;

      var target = button.classList.contains('slider-button--next')
        ? (current + 1) % media.length
        : (current - 1 + media.length) % media.length;

      event.preventDefault();
      event.stopPropagation();
      setActiveMedia(media[target].id);
      preloadNeighbors(media[target].id);
    },
    true
  );

  /* ---------- Lightbox (Bose-Stil) ---------- */

  var lb = { el: null, img: null, media: [], index: 0, lastFocus: null };

  var ICON_CLOSE =
    '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke-width="1.4" stroke-linecap="round"><path d="M4 4l14 14M18 4L4 18"/></svg>';
  var ICON_CHEV_L =
    '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M11.5 3.5 6 9l5.5 5.5"/></svg>';
  var ICON_CHEV_R =
    '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6.5 3.5 12 9l-5.5 5.5"/></svg>';

  function buildLightbox() {
    var root = document.createElement('div');
    root.className = 'sv-lightbox';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Produktbilder');
    root.innerHTML =
      '<button type="button" class="sv-lightbox__close" aria-label="Schließen">' + ICON_CLOSE + '</button>' +
      '<div class="sv-lightbox__stage">' +
      '<button type="button" class="sv-lightbox__arrow sv-lightbox__arrow--prev" aria-label="Vorheriges Bild">' + ICON_CHEV_L + '</button>' +
      '<img class="sv-lightbox__img" alt="">' +
      '<button type="button" class="sv-lightbox__arrow sv-lightbox__arrow--next" aria-label="Nächstes Bild">' + ICON_CHEV_R + '</button>' +
      '</div>' +
      '<div class="sv-lightbox__thumbs" role="list"></div>';
    document.body.appendChild(root);

    root.querySelector('.sv-lightbox__close').addEventListener('click', closeLightbox);
    root.querySelector('.sv-lightbox__arrow--prev').addEventListener('click', function () { lbNavigate(-1); });
    root.querySelector('.sv-lightbox__arrow--next').addEventListener('click', function () { lbNavigate(1); });
    root.addEventListener('click', function (event) {
      if (event.target === root) closeLightbox();
    });

    lb.el = root;
    lb.img = root.querySelector('.sv-lightbox__img');
  }

  var fullImageCache = new Map();
  function loadFull(src) {
    if (!fullImageCache.has(src)) {
      var image = new Image(); image.src = src;
      fullImageCache.set(src, image.decode().then(() => image).catch(error => { fullImageCache.delete(src); throw error; }));
    }
    return fullImageCache.get(src);
  }
  async function lbRender() {
    var m = lb.media[lb.index];
    var request = lb.request = (lb.request || 0) + 1;
    try { await loadFull(m.full); } catch { return; }
    if (request !== lb.request) return;
    lb.img.src = m.full;
    lb.img.alt = m.alt;
    [-1, 1].forEach(step => loadFull(lb.media[(lb.index + step + lb.media.length) % lb.media.length].full).catch(() => {}));

    var thumbsEl = lb.el.querySelector('.sv-lightbox__thumbs');
    if (thumbsEl.childElementCount !== lb.media.length) {
      thumbsEl.innerHTML = '';
      lb.media.forEach(function (m2, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sv-lightbox__thumb';
        b.setAttribute('role', 'listitem');
        b.setAttribute('aria-label', 'Bild ' + (i + 1));
        b.innerHTML = '<img src="' + m2.thumb + '" alt="">';
        b.addEventListener('click', function () {
          lb.index = i;
          lbRender();
        });
        thumbsEl.appendChild(b);
      });
    }

    Array.prototype.forEach.call(thumbsEl.children, function (b, i) {
      if (i === lb.index) {
        b.setAttribute('aria-current', 'true');
      } else {
        b.removeAttribute('aria-current');
      }
    });
  }

  function lbNavigate(step) {
    if (lb.media.length < 2) return;
    lb.index = (lb.index + step + lb.media.length) % lb.media.length;
    lbRender();
  }

  function openLightbox(index, media) {
    if (!lb.el) buildLightbox();
    lb.media = media;
    lb.index = index;
    lb.lastFocus = document.activeElement;
    var currentImage = document.querySelector('.product__media-item[data-media-id="' + media[index].id + '"] img');
    if (currentImage) { lb.img.src = currentImage.currentSrc || currentImage.src; lb.img.alt = currentImage.alt; }
    lbRender();
    lb.el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lb.el.querySelector('.sv-lightbox__close').focus();
    document.addEventListener('keydown', lbOnKey);
  }

  function closeLightbox() {
    if (!lb.el) return;
    lb.el.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', lbOnKey);
    setActiveMedia(lb.media[lb.index].id);
    if (lb.lastFocus && lb.lastFocus.focus) lb.lastFocus.focus();
  }

  function lbOnKey(event) {
    if (event.key === 'Tab') {
      const buttons = [...lb.el.querySelectorAll('button')].filter(el => el.offsetParent !== null);
      if (event.shiftKey && document.activeElement === buttons[0]) { event.preventDefault(); buttons.at(-1)?.focus(); }
      else if (!event.shiftKey && document.activeElement === buttons.at(-1)) { event.preventDefault(); buttons[0]?.focus(); }
    }
    if (event.key === 'Escape') {
      closeLightbox();
    } else if (event.key === 'ArrowLeft') {
      lbNavigate(-1);
    } else if (event.key === 'ArrowRight') {
      lbNavigate(1);
    }
  }

  /* Klick auf ein Hauptbild (nur Bilder) öffnet die Lightbox */
  document.addEventListener(
    'click',
    function (event) {
      var opener = event.target.closest('.product__modal-opener');
      if (!opener) return;
      var viewer = opener.closest('slider-component[id^="GalleryViewer-"]');
      if (!viewer) return;
      var item = opener.closest('.product__media-item');
      if (!item || !item.querySelector('.media-type-image')) return;

      var media = getMediaList();
      if (!media.length) return;

      var id = item.getAttribute('data-media-id');
      var idx = media.findIndex(function (m) { return m.id === id; });

      event.preventDefault();
      event.stopPropagation();
      openLightbox(idx >= 0 ? idx : 0, media);
    },
    true
  );

  /* ---------- Thumbnail-Reihe: Drag-to-Scroll (Maus + Touch) ---------- */
  (function () {
    var lists = document.querySelectorAll('.thumbnail-slider .thumbnail-list');
    Array.prototype.forEach.call(lists, function (list) {
      if (list.dataset.svDrag) return;
      list.dataset.svDrag = '1';
      var isDown = false;
      var startX = 0;
      var startScroll = 0;
      var moved = 0;

      list.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return; /* Touch: natives Scrollen */
        isDown = true;
        moved = 0;
        startX = e.clientX;
        startScroll = list.scrollLeft;
      });

      list.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4 && list.hasPointerCapture && e.pointerId !== undefined) {
          try { list.setPointerCapture(e.pointerId); } catch (err) {}
        }
        moved = Math.max(moved, Math.abs(dx));
        list.scrollLeft = startScroll - dx;
      });

      function up() {
        isDown = false;
      }
      list.addEventListener('pointerup', up);
      list.addEventListener('pointercancel', up);
      list.addEventListener('pointerleave', up);

      /* Klick unterdruecken, wenn tatsächlich gezogen wurde */
      list.addEventListener('click', function (e) {
        if (moved > 6) {
          e.preventDefault();
          e.stopPropagation();
          moved = 0;
        }
      }, true);
    });
  })();
})();
